const GET_APPROVAL_HISTORY_REPORT = "GET_APPROVAL_HISTORY_REPORT"
const SET_APPROVAL_HISTORY_REPORT = "SET_APPROVAL_HISTORY_REPORT"

const GET_APPROVAL_HISTORY_REPORT_EXCEL_DATA = "GET_APPROVAL_HISTORY_REPORT_EXCEL_DATA"
const SET_APPROVAL_HISTORY_REPORT_EXCEL_DATA = "SET_APPROVAL_HISTORY_REPORT_EXCEL_DATA"

const SET_APPROVAL_MANAGMENT_TAB = 'SET_APPROVAL_MANAGMENT_TAB';
const SET_APPROVAL_HISTORY_REPORT_FILTERS = 'SET_APPROVAL_HISTORY_REPORT_FILTERS';

const GET_APPROVAL_HISTORY_REPORT_DETAILS = 'GET_APPROVAL_HISTORY_REPORT_DETAILS'
const SET_APPROVAL_HISTORY_REPORT_DETAILS = 'SET_APPROVAL_HISTORY_REPORT_DETAILS'

const GET_APPROVAL_HISTORY_DETAIL_EXCEL_DATA = 'GET_APPROVAL_HISTORY_DETAIL_EXCEL_DATA'
const SET_APPROVAL_HISTORY_DETAIL_EXCEL_DATA = 'SET_APPROVAL_HISTORY_DETAIL_EXCEL_DATA'

export{
    GET_APPROVAL_HISTORY_REPORT,
    SET_APPROVAL_HISTORY_REPORT,
    GET_APPROVAL_HISTORY_REPORT_EXCEL_DATA,
    SET_APPROVAL_HISTORY_REPORT_EXCEL_DATA,
    SET_APPROVAL_MANAGMENT_TAB,
    SET_APPROVAL_HISTORY_REPORT_FILTERS,
    GET_APPROVAL_HISTORY_REPORT_DETAILS,
    SET_APPROVAL_HISTORY_REPORT_DETAILS,
    GET_APPROVAL_HISTORY_DETAIL_EXCEL_DATA,
    SET_APPROVAL_HISTORY_DETAIL_EXCEL_DATA
}